import React from "react";
import { connect } from 'react-redux';
import lodash from 'lodash';
import MUIDataTable from "mui-datatables";
import i18n from 'i18n';

import { MuiThemeProvider, createMuiTheme } from "@material-ui/core";
import withStyles from "@material-ui/core/styles/withStyles";

import { cardTitle } from "assets/jss/material-dashboard-pro-react.jsx";
import sweetAlertStyle from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.jsx";
import MTablestyles from "assets/jss/material-dashboard-pro-react/customMTableStyle.jsx";

import CustomSweetAlert from "components/SweetAlert/CustomSweetAlert.jsx";
import Badge from "components/Badge/Badge.jsx";
import CustomToolbar from "components/CustomToolbar/CustomToolbar.jsx";
import TableActionButton from "components/CustomToolbar/TableActionButton.jsx"
import TableLoaderSpinner from 'components/Table/TableLoaderSpinner'
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import CloudDownload from "@material-ui/icons/CloudDownload";

import { swalConstants, earnSpecialsConstants, surveyConstants } from '../../constants';
//import { earnSpecialsAction } from "../../actions/earnspecials.actions";
import { surveyAction } from "../../actions/survey.actions";

import { plugins, crmValidator , loader, alert as customAlert } from "helpers";

import CreateSubSurveyForm from "./CreateSubSurveyForm.jsx";

const style = {
   customCardContentClass: {
      paddingLeft: "0",
      paddingRight: "0"
   },
   cardIconTitle: {
      ...cardTitle,
      marginTop: "15px",
      marginBottom: "0px"
   },
   actionDiv: {
      display: "inline-flex"
   },
   textCapital: {
      textTransform: "capitalize"
   }
};

const pageStyle = { ...style, ...sweetAlertStyle };

const THEME = createMuiTheme(MTablestyles);
const moduleName = "earn_rule";

const renderBadgeStatus = (status) => {
   let BadgeColor
   switch (status) {
      case "Active": BadgeColor = "success"; break;
      case "Expired": BadgeColor = "danger"; break;
      default: BadgeColor = "gray";
   }
   return (<Badge color={BadgeColor}>{status}</Badge>)
}

class TableSubSurveyList extends React.Component {
   constructor(props) {
      super(props);

      this.state = {
         readOnly: true,
         page: 0,
         rowsPerPage: 10,
         count: 1,
         data: [],
         reqParams: "",
         selectedSurvey: "",
         surveyList: [],
         showSubSurveyForm: false,
      };

      this.surveyLookup = this.initializeSurveyLookup(props.surveyList);

      this.onSearchChange = lodash.debounce(this.getSubSurveyData, 500)
   }

   initializeSurveyLookup(surveyList) {

      if (!Array.isArray(surveyList)) {
         console.log("surveyListMap",surveyList);
         return {};
      }
      return surveyList.reduce((lookup, survey) => {
         lookup[survey._id] = survey.name;
         return lookup;
      }, {});
   }

   openAddSubSurvey = () => {
      const { dispatch, package_features,surveyId } = this.props;

      let initialValues = {
            surveyId: surveyId,
            questionType: "", 
            question: "",
            questionOrder: "",
            numberAnswer: "",
            numberSelectAnswer: "",
            status_subsurvey: "",
            answer1: "",
            answer2: "",
            answer3: "",
            answer4: "",
            answer5: "",
            answer6: "",
            answer7: "",
            answer8: "",
            answer9: "",
            answer10: "",
            answer11: "",
            answer12: "",
            answer13: "",
            answer14: "",
            answer15: "",
            givePoint1: "",
            givePoint2: "",
            givePoint3: "",
            givePoint4: "",
            givePoint5: "",
            givePoint6: "",
            givePoint7: "",
            givePoint8: "",
            givePoint9: "",
            givePoint10: "",
            givePoint11: "",
            givePoint12: "",
            givePoint13: "",
            givePoint14: "",
            givePoint15: "",

      }
      
      // Temporarily hide the form to force re-render and clear the form
      this.setState({ showSubSurveyForm: false }, () => {
         // Dispatch action after form is hidden
         dispatch({ type: surveyConstants.OPEN_ADD_NEW_SUB_SURVEY, data: initialValues });
         // Re-show the form after resetting state
         this.setState({ showSubSurveyForm: true });
      });
      
   }

   openEditSubSurvey = (rowIndex) => {
      const { dispatch } = this.props;
      const rowData = this.getRowData(rowIndex)
      
      dispatch(surveyAction.getSubSurveyById(rowData._id))
      this.setState({ showSubSurveyForm: true});
   }

   handleDeleteSubSurvey = (rowIndex) => {
        const { dispatch } = this.props;
        const rowData = this.getRowData(rowIndex);
    
        dispatch({
            type: swalConstants.SHOW,
            data: {
              type: "warning",
              title: i18n.t("warning_messages.are_you_sure_delete_question"),
              message: `${rowData.question}`,
              onConfirm: () => { 
                let reqParams = {
                  _id: rowData._id,
                }
                dispatch({ type: swalConstants.HIDE })
            
                 dispatch(surveyAction.deleteSubSurvey(reqParams)).then(() => {
                    // After deletion, fetch the updated data
                    this.getSubSurveyData()
                 });
              },
              onCancel: function() {
                dispatch({ type: swalConstants.HIDE })
              },
              showCancel: true,
              confirmBtnText: i18n.t("delete"),
              cancelBtnText: i18n.t("cancel"),
            },
          })
    }

    getSubSurveyData = (skip, limit, sortBy, sortDir, keyword) => {
      const { dispatch, tableReload,  surveyId } = this.props;

      console.log("surveyId Table",surveyId); 

      let reqParams = "";
      if (!tableReload) {
         if (crmValidator.isEmptyValue(skip)) {
            skip = 0
         }
         if (crmValidator.isEmptyValue(limit)) {
            limit = 10
         }
         this.setState({
            page: skip,
            rowsPerPage: limit
         })
         skip = parseInt(limit) * parseInt(skip)

         reqParams += 'skip=' + skip
         reqParams += '&limit=' + limit

         if (!crmValidator.isEmptyValue(sortBy)) {
            reqParams += '&sortBy=' + sortBy
         }

         if (!crmValidator.isEmptyValue(sortDir)) {
            reqParams += '&sortDir=' + sortDir
         }

         if (!crmValidator.isEmptyValue(surveyId)) {
            reqParams += '&surveyId=' + surveyId;
         }

         if (!crmValidator.isEmptyValue(keyword)) {
            reqParams += '&keyword=' + keyword
         }

      } else {
         reqParams = this.state.reqParams
      }

      dispatch(surveyAction.getSubSurveyLists(reqParams))
      
      this.setState({
         reqParams: reqParams
      });

   }

   componentDidMount() {

      const { dispatch } = this.props;
      dispatch(surveyAction.fetchSurveyList())
      this.getSubSurveyData();
      
   }

   componentDidUpdate() {

      const { tableReload, tableReset, dispatch } = this.props;
      //console.log("tableReload",tableReload);
      //console.log("tableReset",tableReset);
      if (tableReload || tableReset) {
        this.getSubSurveyData();
         dispatch({ type: surveyConstants.TABLE_RELOAD_SUCCESS })

      }

   }

   componentWillMount() {

      const { dispatch } = this.props;
      dispatch({ type: earnSpecialsConstants.CLEAR_PAGE_STATE, data: {} });
      this.getSubSurveyData()

   }

   getRowData(rowIndex = 0) {
      const { tableSubSurveyData } = this.props;
      const data = tableSubSurveyData.subSurvey;
      return data[rowIndex];
   }

   render() {
      
      const { classes, dispatch, tableSubSurveyData, formInitialValue, tableKey, tableLoader, surveyList, readOnlySurvey } = this.props;
      const { rowsPerPage, page, selectedSurvey, showSubSurveyForm } = this.state;

      const surveyOptions = Array.isArray(surveyList.surveys) ? 
      surveyList.surveys.map(survey => ({ value: survey._id, label: survey.name })) : [];

      let columns = [   
        {
            name: "questionId",
            label: "Question ID", 
            options: {
               customBodyRender: (value, tableMeta) => {
                  const rowIndex = tableMeta.rowIndex;
                  const rowData = this.getRowData(rowIndex);
                  if (lodash.has(rowData, 'questionId')) {
                     return rowData.questionId;
                  } else {
                     return ""
                  }
               }
            }          
         },     
         {
            name: "question",
            label: "Question", 
            options: {
               customBodyRender: (value, tableMeta) => {
                  const rowIndex = tableMeta.rowIndex;
                  const rowData = this.getRowData(rowIndex);
                  if (lodash.has(rowData, 'question')) {
                     return rowData.question;
                  } else {
                     return ""
                  }
               }
            }          
         },
         {
            name: "questionType",
            label: "Question Type", 
            options: {
               customBodyRender: (value, tableMeta) => {
                  const rowIndex = tableMeta.rowIndex;
                  const rowData = this.getRowData(rowIndex);
                  if (lodash.has(rowData, 'questionType')) {
                     return rowData.questionType;
                  } else {
                     return ""
                  }
               }
            }          
         },
         {
            name: "status_subsurvey",
            label: "Status", 
            options: {
               customBodyRender: (value, tableMeta) => {
                  const rowIndex = tableMeta.rowIndex;
                  const rowData = this.getRowData(rowIndex);
                  if (lodash.has(rowData, 'status_subsurvey')) {
                     return rowData.status_subsurvey;
                  } else {
                     return ""
                  }
               }
            }          
         },
        
      ]

      if (!readOnlySurvey && plugins.isHasPermission(moduleName, 'read')) {   
         columns.push(
            {
               label: "Action",
               options: {
                  filter: false,
                  sort: false,
                  customBodyRender: (value, tableMeta) => {
                     return (
                        <div className={classes.actionDiv}>
                           
                           {!readOnlySurvey && plugins.isHasPermission(moduleName, 'update') &&
                                <TableActionButton
                                    actionType="edit"
                                    onClick={(e) => {
                                        this.openEditSubSurvey(tableMeta.rowIndex)
                                    }}
                                />
                            }   
                           
                           {!readOnlySurvey && plugins.isHasPermission(moduleName, 'delete') &&
                                <TableActionButton
                                actionType="delete"
                                onClick={(e) => {
                                    this.handleDeleteSubSurvey(tableMeta.rowIndex)
                                }}
                                />
                            }                       
                        </div>
                     )
                  }
               }
            }
         )
      }

      let options = {
         serverSide: true,
         count: tableSubSurveyData.total,
         page: page,
         rowsPerPage: rowsPerPage,
         print: false,
         customToolbar: () => {

            return (
               <>
                  
                  {/* {plugins.isHasPermission(moduleName, 'create') &&( */}
                  {!readOnlySurvey && plugins.isHasPermission(moduleName, 'create') && (     
                     <CustomToolbar handleClick={this.openAddSubSurvey.bind(this)} title="Add New" />
                  )}
               </>
            );
         },

         download: false,
         filter: false,
         selectableRows: "none",
         responsive: "scroll",
         rowsPerPageOptions: [5, 10, 20],
         onTableChange: (action, tableState) => {
            let skip, limit, sortBy, sortDir, keyword = ""

            if (tableState.page !== null) {
               skip = tableState.page
            }

            if (tableState.rowsPerPage !== null) {
               limit = tableState.rowsPerPage
            }

            if (tableState.activeColumn !== null) {
               sortBy = tableState.columns[tableState.activeColumn].name
            }
            if (tableState.announceText !== null) {
               sortDir = tableState.announceText.search("descending") !== -1 ? "desc" : "asc"
            }
            if (tableState.searchText !== null) {
               keyword = tableState.searchText
            }
            let actionList = ['changePage', 'sort', 'search', 'changeRowsPerPage']

            if (actionList.indexOf(action) !== -1) {
               if (action === "search") {
                  this.onSearchChange(skip, limit, sortBy, sortDir, keyword)
               } else {
                  this.getSubSurveyData(skip, limit, sortBy, sortDir, keyword)
               }
            }
         },
      }

      if (!readOnlySurvey && plugins.isHasPermission(moduleName, 'create')) {   
         options.customToolbar = () => {
            return (
               <CustomToolbar handleClick={this.openAddSubSurvey.bind(this)} title="Add New" />
            );
         }
      }

      return (
         <div id="tableSubSurveyList">
            <CustomSweetAlert />
            {showSubSurveyForm && ( 
            <CreateSubSurveyForm
               initialValues={formInitialValue}
               initialQuestionType={formInitialValue.questionType}
               initialNumberAnswer={formInitialValue.numberAnswer}
               initialId={formInitialValue._id}
               tableSubSurveyData={tableSubSurveyData}
               readOnly={!plugins.isHasPermission(moduleName, 'update')}
            />
            )}

            <MuiThemeProvider theme={THEME}>
               <MUIDataTable
                  key={tableKey}
                  title={"Question List"}
                  data={tableSubSurveyData.subSurvey}
                  columns={columns}
                  options={options}
               />
               {tableLoader && <TableLoaderSpinner />}
            </MuiThemeProvider>
         </div>
      )
   }
}

function mapStateToProps(state) {
   const { tableReload, tableReset, tableSubSurveyData, formInitialValue, tableKey, tableLoader, surveyList } = state.survey;
   const { package_features } = state.authentication;
   return {
      tableReload, tableReset, tableSubSurveyData, formInitialValue, tableKey, tableLoader, package_features, surveyList
   };
}

export default connect(mapStateToProps)(withStyles(pageStyle)(TableSubSurveyList));
